import { makeAutoObservable } from 'mobx';

export default class ForkliftStore {
  constructor() {
    this._brands = [];
    this._forklifts = [];
    this._selectedBrand = {};
    this._isLoading = false;
    makeAutoObservable(this);
  }

  setBrands(brands) {
    this._brands = brands || [];
  }

  setForklifts(forklifts) {
    this._forklifts = forklifts || [];
  }

  setSelectedBrand(brand) {
    this._selectedBrand = brand || {};
  }

  setIsLoading(isLoading) {
    this._isLoading = isLoading;
  }

  get brands() {
    return this._brands;
  }

  get forklifts() {
    return this._forklifts;
  }

  get selectedBrand() {
    return this._selectedBrand;
  }

  get isLoading() {
    return this._isLoading;
  }
}